import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Grid from '@material-ui/core/Grid';
import {RestaurantMenu} from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import Loader from "../Loader/Loader";
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from "@material-ui/icons/Star";
import logo from './image.jpeg'
import { Button, Card, CardContent, CardActions } from '@material-ui/core';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    mapView: {
        [theme.breakpoints.up("sm")]: {
            position: 'fixed',
            width: '100%',
            right: '0px'
        }
    },
    tableView: {
        borderCollapse: 'collapse',
        borderSpacing: '0',
        width: '100%',
        border: '1px solid #ddd'
    },

    tableHead: {
        textAlign: 'left',
        padding: '8px'
    }
}));



export default function HotelRooms(props) {
    const [activeIndex, setActiveIndex] = useState(0)
    const classes = useStyles();
    const search = useLocation().search;
    const searchParam = new URLSearchParams(search);
    const check_in_date = searchParam.get("check_in_date");
    const id = searchParam.get("id");
    const check_out_date = searchParam.get("check_out_date");
    const location = searchParam.get("location");
    const adult_count = searchParam.get("adult_count")
    const source_market = searchParam.get("source_market");
    const child_count = searchParam.get("child_count")
    const room_count = searchParam.get("room_count");
    const currency = searchParam.get("currency");

    const [hotel, setHotel] = useState([])
    const [loading, setLoading] = useState(false)

    const searchHotels = async () => {
        if (!check_in_date || !check_out_date || !location || !adult_count)
            return;
        setLoading(true);
        var queryParam = `hotels/search-dida-hotel-rooms?child_count=${child_count}&hotel_id=${id}&check_in_date=${check_in_date}&check_out_date=${check_out_date}&location=${location}&adult_count=${adult_count}&source_market=${source_market}&room_count=${room_count}`;


        if (currency) queryParam += `&currency=${currency}`;

        let response2 = await axios.get(queryParam);
        setLoading(false);
        if (response2 && response2.data && response2.data.data) {
            var data = response2.data.data;
            // if (data.status !== 'complete') {
            //     setTimeout(searchHotels, 3000)
            // } else {

            if (data && data.Success) {
                let d = data.Success.PriceDetails.HotelList
                // }
                // if (data && data.hotels && data.hotels.length > 0) {
                setHotel(d[0]);
            }
            // }
        }

    };

    useEffect(() => {
        searchHotels()
    }, [])

    const getImageUrl = (data) => {
        if (data.links.l) {
            return data.links?.l?.href
        } else if (data.links.m) {
            return data.links.m.href
        } else if (data.links.s) {
            return data.links.s.href
        }
        return ''
    }

    const getImage = (meta_data) => {
        if (meta_data.hero_images && meta_data.hero_images.length > 0) {
            if (meta_data?.hero_images[0].links.m) {
                return meta_data?.hero_images[0].links?.m?.href
            } else if (meta_data?.hero_images[0].links.s) {
                return meta_data?.hero_images[0].links.s.href
            } else if (meta_data?.hero_images[0].links.l) {
                return meta_data?.hero_images[0].links.l.href
            }
        } else if (meta_data.images && meta_data.images.length > 0) {
            let url = ''
            meta_data.images.map((im) => {
                if (im.hero_image) {
                    if (im.links.m) {
                        url = im.links?.m?.href
                    } else if (im.links.s) {
                        url = im.links.s.href
                    } else if (im.links.l) {
                        url = im.links.l.href
                    }
                }
            })
            if (url == '') {
                if (meta_data.images[0].links.m) {
                    url = meta_data.images[0].links?.m?.href
                } else if (meta_data.images[0].links.s) {
                    url = meta_data.images[0].links.s.href
                } else if (meta_data.images[0].links.l) {
                    url = meta_data.images[0].links.l.href
                }
            }
            return url
        }
        return ''
    }

    const navigateToBook = (planId) => {
        let url = `/hotels/book-hotel-room?id=${id}&rate_plan_id=${planId}&check_in_date=${check_in_date}&check_out_date=${check_out_date}&location=${location}&adult_count=${adult_count}&source_market=${source_market}&room_count=${room_count}`;


        if (currency) url += `&currency=${currency}`
        props.history.push(url)
    }

    return (<div className={classes.root} style={{ backgroundColor: "var(--white)", color: "var(--white)", padding: '42px', paddingTop: '100px' }}>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} style={{ marginTop: '40px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} sm={8}>
                                <Grid container>
                                    <Grid item xs={10}>
                                        <Typography
                                            variant="h5"
                                            style={{ color: "var(--darker)", textTransform: "capitalize", textAlign: 'left', fontWeight: '500' }}
                                        >
                                            {hotel?.meta_data?.Name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography component="p" className="text-left">
                                            <StarIcon style={{ color: "var(--green)", fontSize: "20px", marginTop: '-5px' }} /> {hotel?.meta_data?.StarRating}{" "}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{hotel?.meta_data?.Address}{" "}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} sm={8}>
                                <Carousel partialVisible={true}
                                    responsive={responsive}
                                >{hotel?.meta_data && hotel.meta_data.Images ? hotel.meta_data.Images.map((im) => {
                                    return <img style={{ borderRadius: '12px', objectFit: 'cover' }} width="100%" height="450" src={im.ImageUrl} />
                                }) : <img style={{ borderRadius: '12px', objectFit: 'cover' }} width="100%" height="450" src={logo} />}
                                </Carousel>
                            </Grid>
                            <Grid item xs={2}></Grid>

                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} sm={8}>
                                <Grid container spacing={2}>
                                    {hotel?.RatePlanList && hotel?.RatePlanList.map((pack, index) => {
                                        return (<Grid item xs={12} sm={4}><Card>
                                            <CardContent>
                                                <Typography color="text.secondary" gutterBottom>
                                                    {pack?.RatePlanName}&nbsp;
                                                </Typography>

                                                <Typography color="text.secondary">
                                                    {pack?.RoomName}&nbsp;
                                                </Typography>
                                                <Typography variant="h5" component="div">
                                                    {pack?.TotalPrice} {currency}
                                                </Typography>
                                                {pack.BreakfastType === 2 &&
                                                    <Typography variant="body2">
                                                        <RestaurantMenu style={{fontSize:"20px"}}/> Breakfast included
                                                    </Typography>
                                                }
                                                {pack.BreakfastType != 2 &&
                                                    <Typography variant="body2">
                                                        &nbsp;
                                                    </Typography>
                                                }
                                            </CardContent>
                                            <CardContent style={{ textAlign: 'center' }}>
                                                <Button type="submit" variant="contained" style={{ background: 'var(--green)', color: 'white' }} onClick={()=>{
                                                    navigateToBook(pack.RatePlanID)
                                                }}>Book</Button>
                                            </CardContent>
                                        </Card></Grid>)
                                    })}
                                </Grid>
                                {/* <div style={{ overflowX: 'auto' }}>
                                    <table className={classes.tableView} width="100%">
                                        <tr className={classes.tableView}>
                                            <th className={classes.tableView} style={{ width: "25%", color: 'var(--darker)' }}>
                                                Description
                                            </th>
                                            <th className={classes.tableView} style={{ width: "25%", color: 'var(--darker)' }}>
                                                Room Type
                                            </th>
                                            <th className={classes.tableView} style={{ width: "25%", color: 'var(--darker)' }}>
                                                Price
                                            </th>
                                            <th className={classes.tableView} style={{ width: "25%", color: 'var(--darker)' }}>
                                                Action
                                            </th>
                                        </tr>
                                        {hotel?.RatePlanList && hotel?.RatePlanList.map((pack, index) => {
                                            return <tr className={classes.tableView}>
                                                <td className={classes.tableView} style={{ width: "25%" }}>
                                                    <Typography component="p">
                                                        {pack?.RatePlanName}
                                                    </Typography>
                                                </td>
                                                <td className={classes.tableView} style={{ width: "25%" }}>
                                                    <Typography component="p" >
                                                        {pack?.RoomName}
                                                    </Typography>
                                                </td>
                                                <td className={classes.tableView} style={{ width: "25%" }}>
                                                    <Typography component="p" >
                                                        {pack?.TotalPrice} {currency}
                                                    </Typography>
                                                </td>
                                                <td className={classes.tableView} style={{ width: "25%" }}>
                                                    <Button type="submit" variant="contained" style={{ background: 'var(--green)', color: 'white', height: '24px' }}>Book</Button>
                                                </td>


                                            </tr>

                                        })}
                                    </table>
                                </div> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
        <Loader show={loading} />
    </div >)

}